export const CONTRACTS_PAGE_SIZE = 100;
